import PropTypes from 'prop-types';
import React from 'react';

const Header = props => (
  <header>
    {props.title}
    {props.children}
  </header>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};
Header.defaultProps = {
  children: null,
};

export default Header;



// WEBPACK FOOTER //
// ./src/js/components/Header.js